export default class CRSLinesRowData {
    constructor(value) {
        this.custNo = value.custNo[0] || "";
        this.chargeType = value.chargeType[0] || "";
        this.chCode = value.chCode[0] || "";
        this.chargePeriod = value.chargePeriod[0] || "";
        this.desc = value.desc[0] || "";
        this.countryCode = value.countryCode[0] || "";
        this.wwCode = value.wwcode[0] || "";
        this.partnerCode = value.partnerCode[0] || "";
        this.resNo = value.resNo[0] || "";
        this.amount = value.amount[0] || "";
        this.brand = value.brand[0] || "";
        this.loc = value.loc[0] || "";
        this.batchRef = value.batchRef[0] || "";
        this.clInd = value.clind[0] || "";
        this.stInd = value.stInd[0] || "";
    }
}